import { Play } from '@phosphor-icons/react';
import { Button } from 'shared/components/Button/Button';
import { Image } from 'shared/types';
import { renderTitle } from 'shared/utils/renderTitle';

export interface SlideCta {
  to: string
  label: string
}

export interface Slide {
  title: string
  titleHighlight?: string
  description: string
  primaryCta?: SlideCta;
  secondaryCta?: SlideCta;
  image?: Image
}

interface HeroSlideProps {
  slide: Slide;
  visible: boolean;
}

export function HeroSlide({ slide, visible }: HeroSlideProps) {

  const { title, titleHighlight, description, primaryCta, secondaryCta } = slide

  return (
    <div
      className="transition-all duration-1000"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(0.5rem)',
        transitionTimingFunction: visible ? 'ease-in' : 'ease-out',
      }}
    >
      <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-tight mb-8 tracking-tighter max-w-4xl">
        {renderTitle(title, titleHighlight)}
      </h1>

      <p className="font-sans text-xl md:text-2xl text-on-surface-variant mb-10 leading-relaxed max-w-2xl">
        {description}
      </p>

      { primaryCta || secondaryCta ? <div className="flex flex-wrap gap-6 items-center">
        { primaryCta ? 
          <Button
            variant="gold"
            className="group flex items-center gap-4 pl-2 pr-8 py-2"
            to={primaryCta.to}
          >
            <span className="bg-on-tertiary text-tertiary p-3 rounded-full">
              <Play size={20} weight="fill" />
            </span>
            {primaryCta.label}
          </Button> : null
        }
        { secondaryCta ?
          <div className='px-6'>
            <Button variant="underline" to={secondaryCta.to}>
              {secondaryCta.label}
            </Button>
          </div> : undefined
        }
      </div> : null }
    </div>
  );
}
